import React from 'react';
import Toast from './Toast';
import { useToast } from '../../hooks/useToast';

/**
 * Toast 容器组件
 * 管理所有 Toast 的显示位置
 */
const ToastContainer = () => {
  const { toasts, removeToast } = useToast();

  return (
    <div
      className="absolute top-4 right-4 z-[9999] flex flex-col gap-3 pointer-events-none"
      style={{ maxWidth: 'calc(100% - 2rem)' }}
    >
      {toasts.map((toast) => (
        <div key={toast.id} className="pointer-events-auto">
          <Toast
            id={toast.id}
            message={toast.message}
            type={toast.type}
            duration={toast.duration}
            onClose={removeToast}
          />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
